import { Controller } from "@hotwired/stimulus"

// Modal controller for opening/closing modals
export default class extends Controller {
  static targets = ["container", "content"]
  static values = { initialUrl: String }
  
  connect() {
    // Close on escape key
    this.boundKeydown = this.keydown.bind(this)
    document.addEventListener("keydown", this.boundKeydown)
    
    // Auto-open modal if initial URL is provided
    if (this.hasInitialUrlValue && this.initialUrlValue) {
      this.openUrl(this.initialUrlValue)
    }
  }
  
  disconnect() {
    document.removeEventListener("keydown", this.boundKeydown)
  }
  
  open(event) {
    event.preventDefault()
    const url = event.currentTarget.href || event.currentTarget.dataset.modalUrl
    this.openUrl(url)
  }
  
  openUrl(url) {
    
    // Fetch the form content
    fetch(url, { 
      headers: { 
        "Accept": "text/html",
        "X-Requested-With": "XMLHttpRequest"
      }
    })
      .then(response => response.text())
      .then(html => {
        this.contentTarget.innerHTML = html
        this.containerTarget.classList.remove("hidden")
        document.body.classList.add("overflow-hidden")
      })
  }
  
  close(event) {
    if (event) event.preventDefault()
    this.containerTarget.classList.add("hidden")
    document.body.classList.remove("overflow-hidden")
    this.contentTarget.innerHTML = ""
  }
  
  closeBackground(event) {
    if (event.target === this.containerTarget) {
      this.close()
    }
  }
  
  keydown(event) {
    if (event.key === "Escape" && !this.containerTarget.classList.contains("hidden")) {
      this.close()
    }
  }
}
